import './florence-logo.css';
import { ReactComponent as LogoColor } from './florence-logo.svg';
import { ReactComponent as LogoMonochrome } from './florence-logo-monochrome.svg';

const FlorenceLogo = ({ monochrome = false }) => {
  return (
    <div className="florence-logo">
      {monochrome ? <LogoMonochrome /> : <LogoColor />}
    </div>
  );
};

export default FlorenceLogo;
